"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferPromotionPreselectionContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const get_promotion_boost_period_options_1 = require("@src/helpers/get-promotion-boost-period-options");
const useAppQuery_1 = require("@src/hooks/useAppQuery");
const antd_1 = require("antd");
const react_1 = __importDefault(require("react"));
const Api = __importStar(require("api"));
const react_intl_1 = require("react-intl");
const queries_1 = require("@src/types/queries");
const dayjs_1 = __importDefault(require("dayjs"));
const styled_components_1 = __importDefault(require("styled-components"));
const getOfferPromotionStatus_1 = require("@src/helpers/getOfferPromotionStatus");
const OfferPromotionPreselectionContent = ({ setSelectedProductAmount, offerId, setOfferId }) => {
    const intl = (0, react_intl_1.useIntl)();
    const [activeNotPromotedOffers, setActiveNotPromotedOffers] = react_1.default.useState(null);
    const [boostPeriodOptions, setBoostPeriodOptions] = react_1.default.useState([]);
    const [indexOfBoostPeriodOption, setIndexOfBoostPeriodOption] = react_1.default.useState(0);
    const [isInitialized, setIsInitialized] = react_1.default.useState(false);
    const { data: myOffers, isLoading: areMyOffersLoading } = (0, useAppQuery_1.useAppQuery)(queries_1.Queries.getMyOffers, Api.Admin.getMyOffers, {
        onError: err => {
            console.error(err);
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'global.notification_variants.something_went_wrong',
                }),
            });
        },
    });
    const setMaxDaysBoost = (boostOptions) => {
        const indexOfFullDayBoost = boostOptions.findIndex(({ isFullPeriodOption }) => Boolean(isFullPeriodOption));
        const indexOfDesiredValue = indexOfFullDayBoost >= 0 ? indexOfFullDayBoost : 0;
        setSelectedProductAmount(boostOptions[indexOfDesiredValue].boostDayCount);
        setIndexOfBoostPeriodOption(indexOfDesiredValue);
    };
    react_1.default.useEffect(() => {
        if (myOffers) {
            const notPromotedActiveCompanyOffers = myOffers.active.filter(({ id, companyPaymentOfferPromotions }) => !(0, getOfferPromotionStatus_1.getOfferPromotionActiveStatus)(companyPaymentOfferPromotions, id));
            if (!offerId || !notPromotedActiveCompanyOffers.map(({ id }) => id).includes(offerId)) {
                setOfferId(notPromotedActiveCompanyOffers[0].id);
            }
            setActiveNotPromotedOffers(notPromotedActiveCompanyOffers);
        }
    }, [offerId, myOffers]);
    react_1.default.useEffect(() => {
        if (offerId && activeNotPromotedOffers) {
            const { deadline } = activeNotPromotedOffers.find(({ id }) => id === offerId);
            const offerDayCountUntilDeadline = Math.ceil(dayjs_1.default.duration((0, dayjs_1.default)(deadline).diff((0, dayjs_1.default)())).asDays());
            const newBoostPeriodOptions = (0, get_promotion_boost_period_options_1.getBoostPeriodOptions)(offerDayCountUntilDeadline);
            setBoostPeriodOptions(newBoostPeriodOptions);
            setMaxDaysBoost(newBoostPeriodOptions);
        }
    }, [offerId, activeNotPromotedOffers]);
    react_1.default.useEffect(() => {
        if (boostPeriodOptions.length && !isInitialized) {
            setIsInitialized(true);
            setMaxDaysBoost(boostPeriodOptions);
        }
    }, [isInitialized, boostPeriodOptions]);
    if (!myOffers || areMyOffersLoading || !activeNotPromotedOffers || !isInitialized) {
        return ((0, jsx_runtime_1.jsx)(SpinnerContainer, { children: (0, jsx_runtime_1.jsx)(elements_1.Spinner, {}) }));
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex-col justify-center m-m p-m align-center", children: [(0, jsx_runtime_1.jsx)("div", { className: "text-center m-m", children: (0, jsx_runtime_1.jsx)("h2", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.offer_promotion.promote_offer" }) }) }), (0, jsx_runtime_1.jsxs)(OfferSelection, { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.offer_promotion.choose_offer" }), (0, jsx_runtime_1.jsx)(OfferSelectionSelect, { defaultValue: activeNotPromotedOffers[0].id, options: activeNotPromotedOffers.map(({ id, title }) => ({
                            key: id,
                            label: title,
                            value: id,
                        })), onChange: value => setOfferId(value) })] }), Boolean(boostPeriodOptions.length) && ((0, jsx_runtime_1.jsxs)("div", { className: "width-100 m-t-m", children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.offer_promotion.choose_offer_promotion_period" }), (0, jsx_runtime_1.jsx)("div", { className: "width-100", children: (0, jsx_runtime_1.jsx)(StyledRadioGroup, { optionType: "button", defaultValue: 0, onChange: e => {
                                setIndexOfBoostPeriodOption(e.target.value);
                                setSelectedProductAmount(boostPeriodOptions[e.target.value].boostDayCount);
                            }, value: indexOfBoostPeriodOption, children: boostPeriodOptions.map(({ boostDayCount, isFullPeriodOption }, index) => {
                                const periodTitle = isFullPeriodOption
                                    ? `${intl.formatMessage({
                                        id: 'admin.offer_promotion.full_period',
                                    })} (${intl.formatMessage({ id: 'general.day.pluralized' }, { count: boostDayCount })})`
                                    : intl.formatMessage({ id: 'general.day.pluralized' }, { count: boostDayCount });
                                return ((0, jsx_runtime_1.jsx)(StyledRadioButton, { isFullPeriod: isFullPeriodOption, value: index, children: periodTitle }, `${boostDayCount}-${isFullPeriodOption}`));
                            }) }) })] }))] }));
};
exports.OfferPromotionPreselectionContent = OfferPromotionPreselectionContent;
const SpinnerContainer = styled_components_1.default.div `
	display: flex;
	justify-content: center;
	width: 100%;
`;
const OfferSelection = styled_components_1.default.div `
	width: 100%;
`;
const OfferSelectionSelect = (0, styled_components_1.default)(elements_1.Select) `
	width: 100%;
`;
const StyledRadioButton = (0, styled_components_1.default)(antd_1.Radio.Button) `
	display: flex;
	justify-content: center;
	flex: ${({ isFullPeriod }) => (isFullPeriod ? 2 : 1)};
	height: 100%;
`;
const StyledRadioGroup = (0, styled_components_1.default)(elements_1.RadioGroup) `
	display: flex;
	width: 100%;
	height: 100%;
`;
